<li>
    <button
        mat-button
        class="sidebar-menu-item"
        [routerLink]="link"
        [queryParams]="params"
        routerLinkActive="active"
        [disabled]="disabled"
    >
        <span class="nav-item-container" fxLayoutAlign="space-between center" fxLayoutGap=".5em">
            <span fxFlex="1 1 auto" class="nav-item-content">
                <ng-content></ng-content>
            </span>
            <mat-icon class="play-arrows" fxFlex="0 0 auto">play_arrow</mat-icon>
        </span>
    </button>

    <app-sidebar-menu-item-submenu *ngIf="hasSubMenu">
        <ng-content select="[subMenu]"></ng-content>
    </app-sidebar-menu-item-submenu>
</li>
